// internalConsumption.js

import axios from '@/utils/axios'

// GET ALL
export const getInternalConsumptions = (params = {}) => {
  return axios.get('/internal-consumptions', { params })
}

// GET BY ID
export const getInternalConsumptionById = (id) => {
  return axios.get(`/internal-consumptions/${id}`)
}

// DROPDOWN
export const getInternalConsumptionDropdown = () => {
  return axios.get('/internal-consumptions/dropdown')
}

// CREATE
export const createInternalConsumption = (data) => {
  return axios.post('/internal-consumptions', data)
}

// UPDATE
export const updateInternalConsumption = (id, data) => {
  return axios.put(`/internal-consumptions/${id}`, data)
}

// DELETE
export const deleteInternalConsumption = (id) => {
  return axios.delete(`/internal-consumptions/${id}`)
}